import type {GridRowSelectionModel} from '@mui/x-data-grid'
import {createSlice} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import {getUrlParams} from '@app/util-functions'
import type {
  BatchBasicInterface,
  BatchInitialReduxStateInterface,
  BatchInterface,
} from '@shared/interfaces/batch'
import type {LegendItemInterface} from '@shared/interfaces/nivoGraph'

const initialState: BatchInitialReduxStateInterface = {
  selected: [],
  filterURL: '',
  batchesURL: '',
  pageBatch: 0,
  programBatch: 0,
  focusedBatchId: null,
}

export const batches = createSlice({
  name: 'batches',
  initialState,
  reducers: {
    setGlobalSelectedBatches: (
      state,
      action: PayloadAction<
        string[] | BatchInterface[] | BatchBasicInterface[] | GridRowSelectionModel
      >,
    ) => {
      if (action.payload) {
        // Handle MUI X DataGrid v8 selection model format: {type: 'include'|'exclude', ids: Set<GridRowId>}
        let payload: string[] | BatchInterface[] | BatchBasicInterface[]

        if (
          typeof action.payload === 'object' &&
          'ids' in action.payload &&
          action.payload.ids instanceof Set
        ) {
          // v8 format: convert Set to array
          payload = Array.from(action.payload.ids) as string[]
        } else if (Array.isArray(action.payload)) {
          // Array format (v7 or direct array)
          payload = action.payload
        } else {
          // Fallback to empty array
          payload = []
        }

        const batchesIds = payload.map((item) => {
          if (typeof item === 'string') {
            return item
          }
          return (item as BatchInterface | BatchBasicInterface).id
        })
        const filterURL = getUrlParams(batchesIds, 'id')
        const batchesURL = getUrlParams(batchesIds, 'batch')
        return {
          ...state,
          selected: batchesIds,
          filterURL,
          batchesURL,
        }
      }
      return {
        ...state,
        selected: [],
        filterURL: '',
        batchesURL: '',
      }
    },
    setPageBatch: (state, action: PayloadAction<number>) => ({
      ...state,
      pageBatch: action.payload,
    }),
    setPageProgram: (state, action: PayloadAction<number>) => ({
      ...state,
      programBatch: action.payload,
    }),
    setFocusedBatchId: (state, action: PayloadAction<string | null>) => ({
      ...state,
      focusedBatchId: action.payload,
    }),
    setBatchesStates: (state, action: PayloadAction<LegendItemInterface[]>) => ({
      ...state,
      batchesStates: action.payload,
    }),
  },
})

// Action creators are generated for each case reducer function
export const {
  setGlobalSelectedBatches,
  setPageBatch,
  setPageProgram,
  setFocusedBatchId,
  setBatchesStates,
} = batches.actions
export default batches.reducer
